import dialog from './components/dialog';
import filter from './components/filter';
import search from './components/search';
import upload from './components/upload';

export default {
  dialog,
  filter,
  search,
  upload,
};
